import {
  initialState,
  Actions,
  State,
  GET_ALL_FACTURACIONES,
  GET_ALL_FACTURACIONES_SUCCESS,
  GET_ALL_FACTURACIONES_ERROR,
  RESET_GET_ALL_FACTURACIONES,
} from "../../types/facturacion/getAll";

const reducers = (state = initialState, action: Actions): State => {
  switch (action.type) {
    case GET_ALL_FACTURACIONES:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: false,
          success: false,
        },
      };
    case GET_ALL_FACTURACIONES_SUCCESS:
      return {
        ...state,
        data: action.payload,
        states: {
          loading: false,
          error: false,
          success: true,
        },
      };
    case GET_ALL_FACTURACIONES_ERROR:
      return {
        ...state,
        data: null,
        states: {
          loading: true,
          error: action.payload,
          success: false,
        },
      };
    case RESET_GET_ALL_FACTURACIONES:
      return {
        ...state,
        ...initialState,
      };
    default:
      return state;
  }
};

export default reducers;
